import React from "react";
import Header from "./Component/Layout/Header";



function Project (){


    return(
        <>
 <Header />


    <div className="app-content content">
    <h1> Project schedule</h1>
 </div>
        </>
    )
}
export default Project;

